import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlighter',
})
export class HighlighterPipe implements PipeTransform {
  transform(value: any, args: any, type?: string): unknown {
    if (!args || !value) {
      return value;
    }

    const charsToEscape = /[*+?^${}()|[\]\\]/g;

    if (type === 'full') {
      const re = new RegExp(`\\b(${args}\\b)`, 'igm');
      value = value.replace(re, '<span class="highlighted-text">$1</span>');
    } else if (type === 'array') {
      args = args as string[];
      for (const arg of args) {
        const escapedArg = arg.replace(charsToEscape, '\\$&');
        const re = new RegExp(escapedArg, 'igm');
        value = value.replace(
          re,
          (match: string) =>
            `<span class="bold-highlighted-text">${this.escapeAngleBrackets(match)}</span>`,
        );
      }
    } else {
      const escapedArg = args.replace(charsToEscape, '\\$&');
      const re = new RegExp(escapedArg, 'igm');
      value = value.replace(
        re,
        (match: string) =>
          `<span class="highlighted-text">${this.escapeAngleBrackets(match)}</span>`,
      );
    }

    return value;
  }

  private escapeAngleBrackets(str: string): string {
    return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
}
